// Keen Template Files
import './scripts.demo1';

// Require dependencies
import ToastrPolyfill from "@js/toastr-polyfill";

//Bootstrap project
require('./bootstrap');
window.Vue = require('vue');
window.Chart = require('chart.js');
require('@fortawesome/fontawesome-free');
window.Swal = require('sweetalert2');
window.Mime = require('mime-types');
window.toastr = ToastrPolyfill;
// window.SwaggerUIBundle = require('swagger-ui-dist').SwaggerUIBundle;

//Import core stuff
require('./core/customPrototypeMethods');
require('./core/broadcasting');
require('./core/vue.js');
require('./composables/orderStates');

$(function () {
    // expand menu items, if submenu item is selected
    let entry = $('#kt_aside_menu').find('.menu-item-active');
    if (entry.length > 0) {
        let parent = entry.parent();
        do {
            if (parent.hasClass('menu-item-submenu')) {
                parent.addClass('menu-item-active').addClass('menu-item-open');
            }
            parent = parent.parent();
        } while (parent.length > 0);
    }

    //add breadcrumbs to title
    let path = '';
    $('.breadcrumb-item').each(function () {
        path += ' | ' + $(this).text();
    });
    document.title += path;

    //Init boostrap select
    $('.kt-selectpicker').selectpicker();
    $('.selectpicker').selectpicker();
});

window.hexToRgb = function hexToRgb(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });

    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
    } : null;
};

window.initials = function initials(name) {
    let parts = name.split(' ');
    let initials = '';
    for (let part of parts) initials += part.substring(0, 1).toUpperCase();

    return initials;
};

Object.defineProperty(Number.prototype, 'fileSize', {
    value: function (a, b, c, d) {
        return (a = a ? [1e3, 'k', 'B'] : [1024, 'K', 'iB'], b = Math, c = b.log,
            d = c(this) / c(a[0]) | 0, this / b.pow(a[0], d)).toFixed(1) + ' ' + (d ? (a[1] + 'MGTPEZY')[--d] + a[2] : 'Bytes');
    }, writable: false, enumerable: false
});
